import axios from "axios";
import { Dialog, Toast } from "vant";
import { referrer,getLabelList } from "../service/common";
import { delCookie, delQueryString, getCookie, getStorage, GetUrlParam, isWeixin, removeStorage, setCookie, setStorage } from "./common";

export function comeOther(to, next){
  // 来源是app或者小程序 问卷相关 后面会提取到公共项目里面去
  if((to.path==='/questionnaire' && (to.query?.come==='app' || to.query?.come==='xcx')) || (to.path === '/formSet' && to.query?.come==='xcx')){
    axios.get('/cloud/api/account/userInfo',{
      headers: {
        'X-Access-Token': 'Bearer '+GetUrlParam('token')
      }
    }).then(async ({
      data
    }) => {
      // 返回 Promise对象数据
      if (data.code === 1) {
        data.result.token = 'Bearer '+GetUrlParam('token')
        // localStorage.setItem('liveuser', JSON.stringify(data.result))
        setStorage('liveuser', data.result)
        queryMemberList()
        setCookie( 't' ,'wuwei');//存入用户名，设置有效时间1分钟
        let uid = GetUrlParam('exclusiveId')
        if (uid && getStorage('liveuser')?.token) {
          referrer(uid)
        }
        next()
      } else {
        // Toast.fail('登录失败！！请刷新')
      }
     })
    return
  }	
}

export function piciLogin(url, that){
  // console.log(isWeixin())
  if (!(getStorage('liveuser') && getCookie('t'))) {
    if (!GetUrlParam('code')) {
      window.location.href = '/cloud/api/wx/pc/code?redirect='+encodeURIComponent(url)
    }
  } else {
    refer()
  }
}


export function wxLogin(){
  return axios.post('/cloud/api/account/signIn', {
    "gzhCode": GetUrlParam("code"),
    "appId": GetUrlParam('appId')
  })
}

export function pcLogin(){
  return axios.post('/cloud/api/wx/pc/login', {
    "code": GetUrlParam("code"),
    "appId": GetUrlParam('appId')
  })
}

export function weixinLogin(url, that){
  if (!getStorage('liveuser') || !getCookie('t')) {
    removeStorage('liveuser')
    delCookie('t')
    if (!GetUrlParam("code")) {
      window.location.href = `/getcode.php?auk=${encodeURIComponent(url)}&scope=snsapi_userinfo`
    }
  } else {
    // let uid = GetUrlParam('exclusiveId')
    // if (uid && getStorage('liveuser')?.token) {
    //   referrer(uid)
    // }
    // refer()
    let src = GetUrlParam('url')
    that.$router.replace(src);
  }
}

 export function alertHandle(url, that){
    Dialog.alert({
      title: '提示',
      message: '授权失败，点击再次授权',
      confirmButtonText: '重新授权'
    }).then(() => {
      let url = delQueryString(location.href, 'code')
      url = delQueryString(url, 'scope')
      url = delQueryString(url, 'state')
      let str = url.substr(0,1)
      if(str==='?'){
        url = url.substr(1, url.length-1)
      }
      if(isWeixin()){
        // weixinLogin(url, that)
        window.location.href = `/getcode.php?auk=${encodeURIComponent(url)}&scope=snsapi_userinfo`
      } else {
        window.location.href = '/cloud/api/wx/pc/code?redirect='+encodeURIComponent(url)
      }
    })
  }

  export function publicLogin(){
    removeStorage('cancelLogin')
    if(isWeixin()){
      wxLogin().then(async (response) => {
        const { status, data } = response
        let url = delQueryString(location.href, 'code')
        url = delQueryString(url, 'scope')
        url = delQueryString(url, 'state')
        if (status === 200) {
          if (data.code === 1) {
            setCookie('t', 'wuwei');//存入用户名，设置有效时间1分钟
            if(data.result=='undefined'){
              Toast.fail('登录失败！！请刷新')
              localStorage.clear()
              location.reload()
              return
            }
            setStorage('liveuser', data.result)
            refer()
            setTimeout(() => {
              location.replace(url)
            }, 0);
          } else {
            alertHandle(url, this)
          }
        } else {
          alertHandle(url, this)
        }
      })
    } else {
      pcLogin().then(async ({
        data
      }) => {
        let url = delQueryString(location.href, 'code')
        url = delQueryString(url, 'scope')
        url = delQueryString(url, 'state')
        // 返回 Promise对象数据
        if (data.code === 1) {
          setStorage('liveuser', data.result)
          queryMemberList()
          setCookie('t', 'wuwei')
          // refer()
          setTimeout(() => {
            location.replace(url)
          }, 0);
        } else {
          alertHandle(url, this)
        }
      })
    }
  }

  export function refer(){
    // let uid = GetUrlParam('exclusiveId')
    // if (uid && getStorage('liveuser')?.token) {
    //   referrer(uid)
    // }
    let uid = GetUrlParam('exclusiveId') || undefined
    if (getStorage('liveuser')?.token) {
      referrer(uid)
    }
  }

  export function applyAuth(){
    window.location.href = `/getcode.php?auk=${encodeURIComponent(location.href)}&scope=snsapi_userinfo`
  }

 // 查询会员等级数据列表
 export function  queryMemberList (){
   removeStorage('memberLabelList')
   getLabelList().then(res=>{
    const datas = res?.datas ||[];
    setStorage('memberLabelList',datas)
  });
  
}

